<div class="container wrapper-content">
  <div class="page-card-wrapper">
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
  ></app-linker-route>

    <section id="maincontent" class="page-main container cart-experience-shell">
    <a id="contentarea" tabindex="-1"></a>


    <div class="cart-content-grid">
      <div class="cart-items-panel">
        <div class="cart-items-heading">
          <div>
            <h2 class="order-overview-title">Order Overview</h2>
                        </div>
          <div class="cart-items-tools">
            <span class="items-count-chip">
              {{ cartListDetails?.length || 0 }} items
                                </span>
            <span class="delivery-chip" *ngIf="profileData?.zipCode">
              Delivering to {{ profileData?.zipCode }}
                            </span>
                    </div>
                </div>

        <div class="address-card">
          <div class="address-card-header">
            <div>
              <p class="address-label">Shipping Address</p>
              <h3 class="address-name">
                {{ profileData?.firstName }}
                {{ profileData?.lastName }}
              </h3>
            </div>
            <button type="button" class="address-action" (click)="back()">
              <i class="fa fa-map-marker"></i>
              Change
            </button>
                                </div>

          <ng-container *ngIf="!isProfileLoading; else addressLoader">
            <p class="address-text">
              {{ profileData?.addressLine1 }}
              <span *ngIf="profileData?.addressLine2">
                , {{ profileData?.addressLine2 }}
              </span>,
              {{ profileData?.city }},
              {{ profileData?.state }},
              {{ profileData?.country }}
              - {{ profileData?.zipCode }}
            </p>
            <div class="address-meta">
                                <span>
                <i class="fa fa-phone"></i>
                {{ profileData?.countryCode }} {{ profileData?.mobileNumber }}
              </span>
              <span *ngIf="profileData?.email">
                <i class="fa fa-envelope"></i>
                {{ profileData?.email }}
                                </span>
                            </div>
                                        </ng-container>
                                       
          <ng-template #addressLoader>
            <div class="address-skeleton">
                        <ngx-skeleton-loader 
                          [theme]="{ 
                            'border-radius': '8px', 
                  height: '22px',
                  width: '40%'
                          }"
                count="1"
              ></ngx-skeleton-loader>
                        <ngx-skeleton-loader 
                          [theme]="{ 
                            'border-radius': '8px', 
                  height: '16px',
                  width: '90%',
                  'margin-top': '10px'
                          }"
                count="2"
              ></ngx-skeleton-loader>
                      </div>
          </ng-template>
                      </div>

                  <ng-container *ngIf="isLoading">
          <div class="modern-cart-item-card skeleton-card" *ngFor="let shimmer of [1,2,3]">
            <div class="cart-item-image-section">
                          <ngx-skeleton-loader 
                            [theme]="{ 
                  'border-radius': '20px',
                              height: '160px', 
                  width: '150px'
                            }"
                count="1"
              ></ngx-skeleton-loader>
                        </div>
            <div class="cart-item-details-section">
                          <ngx-skeleton-loader 
                            [theme]="{ 
                              'border-radius': '8px', 
                  height: '22px',
                  width: '65%',
                              'margin-bottom': '12px'
                            }"
                count="1"
              ></ngx-skeleton-loader>
                          <ngx-skeleton-loader 
                            [theme]="{ 
                              'border-radius': '8px', 
                  height: '14px',
                  width: '55%',
                  'margin-bottom': '6px'
                }"
                count="3"
              ></ngx-skeleton-loader>
                        </div>
                        </div>
                  </ng-container>

        <ng-container *ngIf="!isLoading && cartListDetails?.length; else emptyCart">
          <div
            class="modern-cart-item-card"
                      *ngFor="let item of cartListDetails; let i = index"
                    >
            <div class="cart-item-image-section">
              <div class="product-image-container">
                <div class="quantity-badge">{{ item?.quantity }}x</div>
                <img
                  [src]="item?.productId?.productImage?.[0] || item?.productId?.thumbnail"
                  [alt]="item?.productId?.productName"
                  class="product-image"
                                loading="lazy"
                />
                      </div>
              <span class="offer-badge" *ngIf="item?.dealDiscount">
                {{ item?.dealDiscount }}% OFF
              </span>
                      </div>

            <div class="cart-item-details-section">
              <div class="item-header">
                <h3 class="product-name">
                            {{ item?.productId?.productName }}
                </h3>
                <span class="delivery-slot" *ngIf="payOutDetail?.deliveryMode">
                  <i class="fa fa-truck"></i>
                  {{ getDeliveryName(payOutDetail?.deliveryMode) }}
                </span>
              </div>

              <div
                class="available-locations"
                *ngIf="item?.productId?.availableLocations"
              >
                <i class="fa fa-map-marker"></i>
                <div class="location-tags">
                  <span
                    class="location-tag"
                    *ngFor="
                      let location of getLocationArray(
                        item?.productId?.availableLocations
                      )
                    "
                  >
                    {{ location }}
                  </span>
                </div>
              </div>

              <div class="price-section">
                <div class="price-block">
                  <span class="price-label">Unit price</span>
                  <div class="price-value">
                    <span class="price-amount regular">
                                    {{
                                      getPrice(
                          (item?.priceSizeDetails?.price)
                            | currency : 'ZAR' : 'R'
                                      )
                                    }}
                                  </span>
                    <span class="price-amount deal" *ngIf="item?.isDealActive">
                      {{
                                    getPrice(
                          item?.dealPrice | currency : 'ZAR' : 'R'
                                    )
                      }}
                                  </span>
                  </div>
                </div>
                <div class="price-block total">
                  <span class="price-label">Total</span>
                  <span class="price-amount emphasis">
                    <ng-container *ngIf="!item?.isDealActive">
                      {{
                                    getPrice(
                          (item?.priceSizeDetails?.price * item?.quantity)
                            | currency : 'ZAR' : 'R'
                        )
                      }}
                              </ng-container>
                    <ng-container *ngIf="item?.isDealActive">
                                    {{
                                      getPrice(
                          (item?.dealPrice * item?.quantity)
                            | currency : 'ZAR' : 'R'
                                      )
                                    }}
                              </ng-container>
                            </span>
                          </div>
                        </div>

              <div class="expected-delivery" *ngIf="payOutDetail?.deliveryMode">
                <span>Expected delivery date:</span>
                <strong>
                  {{ getExpectedDeliveryDate() | date : 'yyyy-MM-dd' }}
                </strong>
              </div>
            </div>
                      </div>
                  </ng-container>

        <ng-template #emptyCart>
          <div class="cart-empty-state">
            <i class="fa fa-shopping-bag empty-icon" aria-hidden="true"></i>
            <h3>Your order bag is empty</h3>
            <p>
              Add premium services and curated products to see them here.
            </p>
            <a class="ghost-link" routerLink="/home">
              Continue shopping
            </a>
          </div>
        </ng-template>
      </div>

      <div class="cart-summary-panel">
        <div id="uf_cartdockable" class="uf_cartdockable">
          <div class="order-summary-container">
            <div class="order-summary-header-bar">
              <i class="fa fa-list header-icon" aria-hidden="true"></i>
              <span class="header-text">Order Summary</span>
            </div>

            <ng-container *ngIf="!isLoading; else summaryLoader">
              <div class="summary-rows">
                <div class="summary-item">
                  <span class="summary-text">
                    Subtotal ({{ cartListDetails?.length || 0 }} items)
                  </span>
                  <span class="summary-value">
                              {{
                                payOutDetail &&
                      getPrice(payOutDetail.subTotal | currency : 'ZAR' : 'R')
                    }}
                  </span>
                </div>
                <div
                  class="summary-item savings"
                  *ngIf="payOutDetail?.totalDiscount"
                >
                  <span class="summary-text">
                    Discount
                          </span>
                  <span class="summary-value">
                    -{{
                                  getPrice(
                        payOutDetail.totalDiscount | currency : 'ZAR' : 'R'
                      )
                    }}
                        </span>
                      </div>
                <div class="summary-item" *ngIf="payOutDetail?.vat">
                  <span class="summary-text">VAT @ 15%</span>
                  <span class="summary-value">
                    +{{
                      getPrice(payOutDetail.vat | currency : 'ZAR' : 'R')
                    }}
                  </span>
            </div>
                <div class="summary-item">
                  <span class="summary-text">
                    Delivery Fee
                  </span>
                  <span class="summary-value delivery-free">
                            {{
                              payOutDetail &&
                                (payOutDetail.deliveryFee
                                  ? getPrice(
                              payOutDetail.deliveryFee | currency : 'ZAR' : 'R'
                                    )
                          : 'Free')
                            }}
                          </span>
        </div>
                <div
                  class="summary-item savings"
                  *ngIf="isCoinRedeem"
                >
                  <span class="summary-text">eXobe coins applied</span>
                  <span class="summary-value">
                    -{{ availableTokenToUse | number : '1.0-0' }}
                          </span>
                  </div>
                <div class="summary-item total-item">
                  <span class="summary-text total-text">Total payable</span>
                  <span class="summary-value total-value">
                    <ng-container *ngIf="!isCoinRedeem">
                      {{
                                payOutDetail &&
                                  getPrice(
                                    payOutDetail.totalAmountWithVat
                            | currency : 'ZAR' : 'R'
                        )
                      }}
                    </ng-container>
                    <ng-container *ngIf="isCoinRedeem">
                      {{
                                payOutDetail &&
                                  getPrice(
                          (payOutDetail.totalAmountWithVat - availableTokenToUse)
                            | currency : 'ZAR' : 'R'
                                  )
                              }}
                    </ng-container>
                        </span>
                      </div>
                    </div>
                    
              <div class="loyalty-row" *ngIf="availableTokenToUse > 0">
                <label class="loyalty-checkbox">
                  <input
                    type="checkbox"
                    (change)="isCoinRedeem = !isCoinRedeem"
                    [checked]="isCoinRedeem"
                  />
                  <span>Redeem {{ availableTokenToUse }} eXobe coins</span>
                </label>
                <p class="loyalty-hint">
                  Coins knock off instantly from your total and keep the same order flow.
                </p>
              </div>

              <div class="checkout-action-stack">
                    <button
                      type="button"
                  class="checkout-proceed-button premium-trigger"
                  data-toggle="modal"
                  data-target="#premiumPaymentModal"
                  [disabled]="!cartListDetails?.length"
                >
                  <div class="checkout-button-content">
                    <div class="checkout-left">
                      <span class="checkout-button-text">
                        <span class="checkout-line-1">Proceed to </span>
                        <span class="checkout-line-2">Payment</span>
                        </span>
                      </div>
                    </div>
                    </button>
                <small class="checkout-hint">
                  The button opens a premium payment window with all methods.
                </small>
                <div class="screen-reader-only" aria-hidden="true" *ngIf="htmlData">
                    <div [innerHTML]="htmlData"></div>
                  </div>
                </div>

              <div class="secure-checkout-row">
                  <div class="secure-item">
                  <i class="fa fa-shield secure-icon" aria-hidden="true"></i>
                  <span class="secure-text">Secure checkout</span>
              </div>
                  <div class="secure-item">
                  <i class="fa fa-undo secure-icon" aria-hidden="true"></i>
                  <span class="secure-text">Easy returns</span>
              </div>
                  <div class="secure-item">
                  <i class="fa fa-truck secure-icon" aria-hidden="true"></i>
                  <span class="secure-text">Fast delivery</span>
                </div>
              </div>
            </ng-container>

            <ng-template #summaryLoader>
              <div class="summary-skeleton">
                <ngx-skeleton-loader 
                  [theme]="{ 
                    'border-radius': '10px',
                    height: '16px',
                    width: '100%',
                    'margin-bottom': '12px'
                  }"
                  count="5"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader 
                  [theme]="{ 
                    'border-radius': '12px', 
                    height: '52px',
                    width: '100%',
                    'margin-top': '16px'
                  }"
                  count="1"
                ></ngx-skeleton-loader>
              </div>
            </ng-template>
              </div>
              
          <div class="feature-guarantee-cards">
            <div class="guarantee-card">
              <i class="fa fa-shield guarantee-icon" aria-hidden="true"></i>
              <span class="guarantee-text">100% Secure</span>
            </div>
            <div class="guarantee-card">
              <i class="fa fa-undo guarantee-icon" aria-hidden="true"></i>
              <span class="guarantee-text">30-Day Returns</span>
            </div>
            <div class="guarantee-card">
              <i class="fa fa-truck guarantee-icon" aria-hidden="true"></i>
              <span class="guarantee-text">Free Delivery</span>
            </div>
            <div class="guarantee-card">
              <i class="fa fa-headphones guarantee-icon" aria-hidden="true"></i>
              <span class="guarantee-text">24/7 Support</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</div>

<div
  class="modal fade premium-payment-modal"
  id="premiumPaymentModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered premium-dialog">
    <div class="modal-content premium-modal">
      <button type="button" class="premium-close-btn" data-dismiss="modal" aria-label="Close">
        <i class="fa fa-times"></i>
      </button>
      <div class="premium-modal-header">
        <div class="payment-header-content">
          <i class="fa fa-credit-card payment-header-icon"></i>
          <h3 class="premium-modal-title">Payment Information</h3>
        </div>
        <p class="premium-modal-subtitle">Select Payment Gateway</p>
      </div>
      <div class="premium-modal-body">
        <ng-container *ngIf="!htmlData; else premiumHtmlBlock">
          <div class="premium-payment-section">
            <ng-container *ngIf="flag; else premiumProcessing">
              <div class="payment-option-list">
                <ng-container *ngFor="let item of dropDownData; let i = index">
                  <div
                    class="payment-option"
                    *ngIf="i > 0"
                    [class.selected]="selectedPaymentMethod === item.value"
                    (click)="setSelectedPayment(item.value); $event.stopPropagation()"
                  >
                    <div class="payment-option-content">
                      <div class="payment-icon-wrapper">
                        <img 
                          [src]="getPaymentLogo(item.value)" 
                          [alt]="getPaymentName(item.name, item.value)"
                          class="payment-logo-image"
                        />
                      </div>
                      <div class="payment-details">
                        <div class="payment-header-row">
                          <span class="payment-name">{{ getPaymentName(item.name, item.value) }}</span>
                        </div>
                        <p class="payment-description">{{ getPaymentDescription(item.value) }}</p>
                        <div class="payment-security-features" *ngIf="getPaymentSecurityFeatures(item.value).length > 0">
                          <span 
                            class="security-feature" 
                            *ngFor="let feature of getPaymentSecurityFeatures(item.value); let last = last"
                          >
                            {{ feature }}
                            <span class="security-separator" *ngIf="!last"> • </span>
                          </span>
                        </div>
                      </div>
                      <div class="payment-card-types" *ngIf="getPaymentCardTypes(item.value).length > 0">
                        <span 
                          class="card-type" 
                          *ngFor="let cardType of getPaymentCardTypes(item.value)"
                        >
                          {{ cardType }}
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              
              <div class="payment-modal-actions">
                <button 
                  type="button" 
                  class="btn-cancel" 
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  class="btn-proceed-payment"
                  [disabled]="!selectedPaymentMethod"
                  (click)="selectPayment(selectedPaymentMethod)"
                  data-dismiss="modal"
                >
                  Make Payment
                </button>
              </div>
            </ng-container>
            <ng-template #premiumProcessing>
              <div class="payment-processing-loader">
                <div class="spinner"></div>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <ng-template #premiumHtmlBlock>
          <div class="premium-html-display" [innerHTML]="htmlData"></div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="itemDeleteModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered order-delete-modal" role="document">
    <div class="modal-content ggg order-delete-modal__content">
      <div class="order-delete-modal__icon-wrapper">
        <img
          class="for-img1 order-delete-modal__icon"
          src="assets/latest/logoutui.png"
          alt="Delete item"
        />
      </div>
      <h2
        class="modal-title okay order-delete-modal__title"
      >
        Are you sure you want to delete <br />
        this item?
      </h2>
      <div class="modal-body order-delete-modal__actions">
        <button type="button" class="btn order-delete-btn-secondary" data-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn order-delete-btn-primary"
          data-dismiss="modal"
          (click)="removeCartList()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="choosePaymentModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered choose-payment-modal" role="document">
    <div class="modal-content ggg choose-payment-modal__content">
      <div class="choose-payment-modal__icon-wrapper">
        <img
          class="for-img1 choose-payment-modal__icon"
          src="assets/latest/logoutui.png"
          alt="Choose payment"
        />
      </div>
      <h2
        class="modal-title okay choose-payment-modal__title"
      >
        Sele
      </h2>
      <div class="modal-body choose-payment-modal__actions">
        <button type="button" class="btn choose-payment-btn-secondary" data-dismiss="modal">
          No
        </button>
        <!-- Existing commented payment buttons kept as-is for logic reference -->
      </div>
    </div>
  </div>
</div>

